import { Link } from 'react-router-dom';
import type { TvShow } from '@/mocks/tv-shows';

interface TvShowCardProps {
  show: TvShow;
  variant?: 'default' | 'ranking';
  rank?: number;
}

export default function TvShowCard({ show, variant = 'default', rank }: TvShowCardProps) {
  if (variant === 'ranking') {
    return (
      <Link
        to={`/article/${show.id}`}
        className="flex items-center gap-3 p-3 rounded-lg hover:bg-background-100 transition-colors group cursor-pointer"
      >
        <span className={`font-heading text-lg font-bold w-7 text-center ${
          rank && rank <= 3 ? 'text-accent-500' : 'text-foreground-400'
        }`}>
          {rank || '-'}
        </span>
        <div className="relative w-12 h-16 rounded-md overflow-hidden flex-shrink-0">
          <img
            src={show.imageUrl}
            alt={show.title}
            title={`${show.title} - 老子影视网${show.category}全集在线播放`}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
            {show.title}
          </h4>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-accent-500 font-medium">
              <i className="ri-star-fill text-[10px] mr-0.5"></i>{show.rating}
            </span>
            <span className="text-xs text-foreground-500">{show.updateInfo}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${show.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
        <img
          src={show.imageUrl}
          alt={show.title}
          title={`${show.title} - 老子影视网${show.category}全集在线播放`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        {show.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
            NEW
          </span>
        )}
        {show.isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
            热播
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-accent-400 text-xs">
            <i className="ri-star-fill text-[10px]"></i>
            <span className="font-semibold">{show.rating}</span>
            <span className="text-white/60 ml-1">{show.updateInfo}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
        {show.title}
      </h3>
      <div className="flex items-center gap-2 mt-1.5">
        <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
          {show.category}
        </span>
        <span className="text-xs text-foreground-500">{show.year}</span>
      </div>
    </Link>
  );
}